export function setSettingsToRetrieve(settingsToRetrieve) {
    return dispatch => dispatch({
        type: "SET_SETTINGS",
        settingsToRetrieve
    });
}